// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/MaterialMovementLedger.jsx
// =============================================================================

import React from "react";

import styles
  from "./siteStoreDashboardStyles";

// =============================================================================
// COMPONENT
// =============================================================================

export default function MaterialMovementLedger({

  ledgerRows = []

}) {

  // ===========================================================================
  // TRANSACTION TYPE COLOR
  // ===========================================================================

  const getTypeStyle =
    (type) => {

      switch (type) {

        case "ISSUE":

          return {
            background: "#dbeafe",
            color: "#1d4ed8"
          };

        case "CONSUMPTION":

          return {
            background: "#dcfce7",
            color: "#15803d"
          };

        case "RETURN":

          return {
            background: "#ecfccb",
            color: "#4d7c0f"
          };

        case "SCRAP":

          return {
            background: "#fee2e2",
            color: "#dc2626"
          };

        default:

          return {
            background: "#f3f4f6",
            color: "#374151"
          };
      }
    };

  // ===========================================================================
  // RENDER
  // ===========================================================================

  return (

    <div
      style={{
        marginTop: 20
      }}
    >

      {/* ================================================================ */}
      {/* TITLE */}
      {/* ================================================================ */}

      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          marginBottom: 12
        }}
      >

        Material Movement Ledger

      </div>

      {/* ================================================================ */}
      {/* EMPTY */}
      {/* ================================================================ */}

      {
        ledgerRows.length === 0 && (

          <div style={styles.emptyTd}>

            No movement history found

          </div>
        )
      }

      {/* ================================================================ */}
      {/* TABLE */}
      {/* ================================================================ */}

      {
        ledgerRows.length > 0 && (

          <div style={styles.tableWrap}>

            <table style={styles.table}>

              <thead style={styles.thead}>

                <tr style={styles.theadRow}>

                  <th style={styles.th}>
                    Date
                  </th>

                  <th style={styles.th}>
                    Type
                  </th>

                  <th style={styles.thRight}>
                    Qty
                  </th>

                  <th style={styles.th}>
                    Reference
                  </th>

                  <th style={styles.th}>
                    Status
                  </th>

                  <th style={styles.th}>
                    Remarks
                  </th>

                </tr>

              </thead>

              <tbody>

                {
                  ledgerRows.map((row, index) => (

                    <tr
                      key={index}
                      style={styles.tr}
                    >

                      {/* DATE */}

                      <td style={styles.td}>

                        {
                          row.transaction_date
                        }

                      </td>

                      {/* TYPE */}

                      <td style={styles.td}>

                        <span
                          style={{
                            padding:
                              "4px 10px",

                            borderRadius: 999,

                            fontSize: 12,

                            fontWeight: 700,

                            ...getTypeStyle(
                              row.transaction_type
                            )
                          }}
                        >

                          {
                            row.transaction_type
                          }

                        </span>

                      </td>

                      {/* QTY */}

                      <td style={styles.tdRight}>

                        {
                          row.quantity
                        }

                      </td>

                      {/* REF */}

                      <td style={styles.td}>

                        {
                          row.reference_no
                        }

                      </td>

                      {/* STATUS */}

                      <td style={styles.td}>

                        {
                          row.status
                        }

                      </td>

                      {/* REMARKS */}

                      <td style={styles.td}>

                        {
                          row.remarks || "-"
                        }

                      </td>

                    </tr>
                  ))
                }

              </tbody>

            </table>

          </div>
        )
      }

    </div>
  );
}